/*********** Reduceres defined here *********/

import { persistCombineReducers } from 'redux-persist'
import storage from 'redux-persist/es/storage' // default: localStorage if web, AsyncStorage if react-native
import { routerReducer as router } from 'react-router-redux'
import encryptor from './encryptor'
import user from './modules/user'
import merchant from './modules/merchant'
import loader from './modules/loader'
import staticpages from './modules/staticpages'
import dashboard from './modules/dashboard'
import items from './modules/items'
import admin from './modules/admin'
import settings from './modules/settings'
import feedback from './modules/feedback'
import socialMedia from './modules/socialMedia'
import redeem from './modules/redeem';
import faq from './modules/faq';

import rewards from './modules/rewards';
import adminPageInfo from './modules/adminPageInfo';
import merchantProfile from './modules/merchantProfile';
import featured from './modules/featured'

const userPersistConfig = {
    key: 'cityofglen-app',
    storage: storage,
    transforms: [encryptor],
    blacklist: ['loader'],
}

export default persistCombineReducers(userPersistConfig, {
    loader,
    user,
    staticpages,
    router,
    merchant,
    dashboard,
    redeem,
    items,
    feedback,
    admin,
    settings,
    socialMedia,
    faq,

    rewards,
    adminPageInfo,
    merchantProfile,
    featured
})
